import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const links: Record<string, string> = {
  back: '/infoTrac/reverse-mail-tracking/search-result',
};

function ReverseMailDetails() {
  const [searchParams] = useSearchParams();
  const [path, setPath] = useState<string>();

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const name = searchParams.get('name');

    if (name) {
      setPath(`../oldPages/reverseMail/details/index-${name}.html`);
    }
  }, [searchParams.get('name')]);

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const back = iframeDocument.getElementById('backBtn');

      if (back) back.addEventListener('click', () => navigate(links.back));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, [path]);

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      {path ? <iframe ref={iframeRef} title="reverseMailDetails" src={path} className="flex-grow border-none" /> : null}
    </div>
  );
}

export default ReverseMailDetails;
